import { toast } from "react-toastify";
import i18next from "i18next";

// Regular expression for basic email validation
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validates required fields with additional rules (max length, special characters, email validation).
 * @param {Object} fields - Key-value pairs of field names and their values.
 * @param {Array} requiredFields - Array of objects containing field names and their types (e.g., 'text', 'email').
 * @param {number} maxLength - Maximum allowed length for each field.
 * @param {RegExp} allowedCharsRegex - Regex to validate allowed special characters.
 * @returns {boolean} - Returns true if all validations pass, otherwise false.
 */
const validateFields = (
    fields,
    requiredFields,
    selectedScreen,
    maxLength,
    allowedCharsRegex = /.*/
) => {
    let defaultMaxLength = maxLength || 50;

    const showError = (msg) => {
        toast.error(msg, { position: "top-center", theme: "dark" });
    };

    const isValidText = (value) =>
        allowedCharsRegex.test(value) || /.*/.test(value);

    for (const fieldObj of requiredFields) {
        let key, type, value, charLength;
        if (selectedScreen === "byValue") {
            ({ key, type, value, charLength } = fieldObj);
            defaultMaxLength = charLength;
        } else {
            ({ key, type } = fieldObj);
            value = fields[key];
        }

        if (!value) {
            showError(
                `${i18next.t('missingRequiredField')}: ${fieldObj.label || key.replace(/([A-Z])/g, " $1").trim()}`
            );
            return false;
        }

        if (value.length > defaultMaxLength) {
            showError(
                `${key} exceeds the maximum length of ${defaultMaxLength} characters.`
            );
            return false;
        }

        if (type === "email" && !emailRegex.test(value)) {
            showError(`${key} is not a valid email address.`);
            return false;
        }

        if (type === "number" && value < 0) {
            showError(`Negative numbers are not allowed.`);
            return false;
        }

        if (type === "text" && !isValidText(value)) {
            showError(
                `${key} contains invalid characters. Allowed: @, #, $, %, &, *, _, -, ,`
            );
            return false;
        }
    }
    return true;
};
export default validateFields;

const validateFileUploadFields = (fileData, requireFields, lang, t) => {
   console.log("File Data in Validation:", requireFields);
     // Add DistributionListIds if Confidential
    if (fileData.AccessibleTo === "Confidential") {
        requireFields.push({ key: "DistributionListIds", label: t("selectDistributionList") });
    }

    // Validate each required field
    for (const field of requireFields) {
        const value = fileData[field.key];
        if (
            value === undefined ||
            value === null ||
            (typeof value === "string" && value.trim() === "") ||
            (Array.isArray(value) && value.length === 0)
        ) {
            toast.error(`${t("missingRequiredField")}: ${field.label}`, {
                position: "top-center",
                theme: "dark",
            });
            return false;
        }
    }
    return true;
};
export { validateFileUploadFields };